import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './self-description.reducer';

export const SelfDescriptionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const selfDescriptionEntity = useAppSelector(state => state.selfDescription.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="selfDescriptionDetailsHeading">
          <Translate contentKey="fivePlusApp.selfDescription.detail.title">SelfDescription</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{selfDescriptionEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fivePlusApp.selfDescription.description">Description</Translate>
            </span>
          </dt>
          <dd>{selfDescriptionEntity.description}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.selfDescription.user">User</Translate>
          </dt>
          <dd>{selfDescriptionEntity.user ? selfDescriptionEntity.user.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/self-description" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/self-description/${selfDescriptionEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SelfDescriptionDetail;
